import { hotExposes } from '@/mocks/homeData';

export default function HotExpose() {
  const [featured, ...rest] = hotExposes;

  return (
    <section id="hot" aria-labelledby="hot-title" className="scroll-mt-28 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-4 border-b border-background-200 pb-6 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs tracking-[0.25em] text-primary-600">HOT REVEAL</p>
            <h2 id="hot-title" className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              热门爆料
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            热度最高的几条正在持续追踪。每条都标注了当前状态:是首发实锤,还是仍在核实。
          </p>
        </div>

        <article className="mt-8 grid grid-cols-1 overflow-hidden rounded-lg border border-background-200 bg-background-100 lg:grid-cols-2">
          <div className="relative h-56 w-full sm:h-72 lg:h-full lg:min-h-[360px]">
            <img
              src={featured.image}
              alt={featured.title}
              className="h-full w-full object-top"
            />
            <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-3 py-1.5 text-xs text-background-50">
              <i className="ri-flashlight-fill" aria-hidden="true" />
              {featured.tag}
            </span>
          </div>
          <div className="flex flex-col justify-between p-6 md:p-8">
            <div>
              <h3 className="font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                {featured.title}
              </h3>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600">{featured.summary}</p>
            </div>
            <ul className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2 border-t border-background-200 pt-4 text-xs text-foreground-500">
              <li className="flex items-center gap-1.5">
                <i className="ri-user-line" aria-hidden="true" />
                <span className="sr-only">作者:</span>
                {featured.author}
              </li>
              <li className="flex items-center gap-1.5">
                <i className="ri-time-line" aria-hidden="true" />
                <span className="sr-only">发布时间:</span>
                {featured.time}
              </li>
              <li className="flex items-center gap-1.5 text-primary-600">
                <i className="ri-fire-line" aria-hidden="true" />
                <span className="sr-only">热度:</span>
                {featured.heat} 围观
              </li>
            </ul>
          </div>
        </article>

        <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {rest.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-300"
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-md bg-background-50/95 px-2.5 py-1 text-xs text-primary-700">
                  {item.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-base font-bold leading-snug text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                  {item.summary}
                </p>
                <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-1 border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-time-line" aria-hidden="true" />
                    {item.time}
                  </span>
                  <span className="flex items-center gap-1.5 text-primary-600">
                    <i className="ri-fire-line" aria-hidden="true" />
                    {item.heat}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}